import { render, staticRenderFns } from "./SportelloUserInfoView.vue?vue&type=template&id=4cd1c722&"
import script from "./SportelloUserInfoView.vue?vue&type=script&lang=ts&"
export * from "./SportelloUserInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports